import { rtkApi } from './api';

const enhancedApiV3Balance = rtkApi.enhanceEndpoints({
    endpoints: {
        getApiV3Balance: {
            async onQueryStarted(_, { queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch(error) {
                    console.error(error);
                }
            }
        }

    }
});

export const { useGetApiV3BalanceQuery } = enhancedApiV3Balance;

export { enhancedApiV3Balance };
